
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
import { email } from "@/validators";
import { requiredIf } from "vuelidate/lib/validators";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  watch: {
    "$v.$invalid": "setValidity"
  },
  data() {
    return {};
  },
  computed: {
    applicantEmailAddress: {
      get(): any {
        return (
          store.state.application.applicationData &&
          store.state.application.applicationData.email
        );
      },
      set(value: string) {
        (this as any).$v.applicantEmailAddress.$touch();

        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_APPLICANT_EMAIL_ADDRESS),
          value
        );
      }
    },
    ...mapState({
      applicantFullName: (state: IApplicationState) =>
        state.applicationData && state.applicationData.fullName,
      receiveCorrespondence: (state: IApplicationState) =>
        state.applicationData && state.applicationData.receiveCorrespondence
    }),
    ...mapGetters([APPLICATION.GETTERS.IS_EDITABLE])
  },
  methods: {
    setValidity() {
      this.$emit("isvalid", "applicant", !(this as any).$v.$invalid);
    }
  },
  validations: {
    applicantEmailAddress: {
      required: requiredIf(vm => vm.isEditable),
      email
    }
  }
});
